const state = {
  currentAssetCode: null,
  outputsError: false,
  modifiedNodes: {
    outputs: {},
    inputs: {}
  }
};
const getters = {
  getGraphedAssetCode: (state) => state.currentAssetCode,
  isOutputsLoadError: (state) => state.outputsError,
  modifiedAssetNodes: (state) => state.modifiedNodes
};
const actions = {
};
const mutations = {
  setGraphedAssetCode(state, assetCodeData) {
    state.currentAssetCode = assetCodeData
  },
  setOutputsLoadError(state, bool) {
    state.outputsError = bool
  },
  setModifiedNode(state, { nodeType, nodeId, oldData, newData }) {
    console.log(`Setting modified node. Type: ${nodeType}, ID: ${nodeId}`)
    let changesSummmaryObj = {}
    if (oldData.asset_code != newData.asset_code) {
      changesSummmaryObj.assetCodeChange = { from: oldData.asset_code, to: newData.asset_code }
    }
    if (oldData.asset_iteration != newData.asset_iteration) {
      changesSummmaryObj.assetIterationChange = { from: oldData.asset_iteration, to: newData.asset_iteration }
    }
    if (nodeType == "outputs" && oldData.asset_system_level != newData.asset_system_level) {
      changesSummmaryObj.assetSystemLevelChange = { from: oldData.asset_system_level, to: newData.asset_system_level }
    }
    changesSummmaryObj.data = newData
    state.modifiedNodes[nodeType][nodeId] = changesSummmaryObj
    console.log("Set modified node: ", nodeType, nodeId, state.modifiedNodes[nodeType][nodeId])
  },
  removeModifiedNode(state, { nodeType, nodeId}) {
    console.log(`Removing modified node. Type: ${nodeType}, ID: ${nodeId}`)
    delete state.modifiedNodes[nodeType][nodeId]
    console.log("Removed modified node. Current modified nodes: ", state.modifiedNodes)
  },
  resetModifiedNodes(state) {
    state.modifiedNodes = {
      outputs: {},
      inputs: {}
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};